import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ade11f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass('total-price')
}
const _hoisted_2 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass('total-price')
}
const _hoisted_3 = {
  key: 2,
  class: /*#__PURE__*/_normalizeClass('total-price')
}
const _hoisted_4 = {
  key: 3,
  class: /*#__PURE__*/_normalizeClass('total-price')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_DescriptionBlock = _resolveComponent("DescriptionBlock")!
  const _component_FormFieldCheckbox = _resolveComponent("FormFieldCheckbox")!
  const _component_FormFieldComboBox = _resolveComponent("FormFieldComboBox")!
  const _component_NorthIcon = _resolveComponent("NorthIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_SouthIcon = _resolveComponent("SouthIcon")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_BaseTable = _resolveComponent("BaseTable")!

  return (_openBlock(), _createBlock(_component_BaseTable, {
    "column-defs": _ctx.columnDefs,
    "row-data": _ctx.priceMultipleValues,
    loading: false,
    enumerable: true
  }, {
    "cell(name)": _withCtx(({ row, rowIndex }) => [
      _createVNode(_component_FormField, {
        value: row.name,
        "onUpdate:value": ($event: any) => ((row.name) = $event),
        name: `[${rowIndex}][name]`
      }, null, 8, ["value", "onUpdate:value", "name"]),
      _createVNode(_component_DescriptionBlock, {
        description: row.description
      }, null, 8, ["description"])
    ]),
    "cell(price)": _withCtx(({ row, rowIndex }) => [
      _createVNode(_component_FormField, {
        value: row.price,
        "onUpdate:value": ($event: any) => ((row.price) = $event),
        type: "number",
        name: `[${rowIndex}][price]`
      }, null, 8, ["value", "onUpdate:value", "name"]),
      _createTextVNode("z ")
    ]),
    "cell(discount)": _withCtx(({ row, rowIndex }) => [
      _createElementVNode("div", null, [
        _createVNode(_component_FormFieldCheckbox, {
          checked: row.onDiscount,
          "onUpdate:checked": ($event: any) => ((row.onDiscount) = $event),
          label: "Включить скидку",
          name: `[${rowIndex}][onDiscount]`
        }, null, 8, ["checked", "onUpdate:checked", "name"]),
        (row.onDiscount)
          ? (_openBlock(), _createBlock(_component_FormFieldComboBox, {
              key: 0,
              value: row.discountType,
              "onUpdate:value": ($event: any) => ((row.discountType) = $event),
              label: "Тип скидки",
              name: `[${rowIndex}][discountType]`,
              clearable: true,
              options: _ctx.discountTypeOption,
              onChange: 
            () => {
              _ctx.resetDiscountValue(rowIndex);
            }
          
            }, null, 8, ["value", "onUpdate:value", "name", "options", "onChange"]))
          : _createCommentVNode("", true),
        (row.onDiscount)
          ? (_openBlock(), _createBlock(_component_FormField, {
              key: 1,
              id: `[${rowIndex}][discountValue]`,
              value: row.discountValue,
              "onUpdate:value": ($event: any) => ((row.discountValue) = $event),
              type: "number",
              label: row.discountType ? row.discountType.label : '...',
              name: `[${rowIndex}][discountValue]`,
              class: "no-margin"
            }, null, 8, ["id", "value", "onUpdate:value", "label", "name"]))
          : _createCommentVNode("", true)
      ])
    ]),
    "cell(total)": _withCtx(({ row }) => [
      (
          row.discountType &&
          row.onDiscount &&
          row.discountType.value === 'PERCENT'
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.getDiscountPricePercent(row.price, row.discountValue)) + " руб. ", 1))
        : (
          row.discountType &&
          row.onDiscount &&
          row.discountType.value === 'VALUE'
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.getDiscountPriceValue(row.price, row.discountValue)) + " руб. ", 1))
          : (
          row.discountType &&
          row.onDiscount &&
          row.discountType.value === 'PRICE'
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(row.discountValue ? row.discountValue : "0") + " руб. ", 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(row.price) + " руб. ", 1))
    ]),
    "cell(actions)": _withCtx(({ rowIndex }) => [
      _createElementVNode("div", null, [
        _createVNode(_component_BaseButton, {
          variant: "icon",
          title: "Move up",
          disabled: rowIndex === 0,
          onClick: ($event: any) => (_ctx.moveItem(rowIndex, 'up'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NorthIcon)
          ]),
          _: 2
        }, 1032, ["disabled", "onClick"]),
        _createVNode(_component_BaseButton, {
          variant: "icon",
          title: "Move down",
          disabled: rowIndex === _ctx.priceMultipleValues.length - 1,
          onClick: ($event: any) => (_ctx.moveItem(rowIndex, 'down'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SouthIcon)
          ]),
          _: 2
        }, 1032, ["disabled", "onClick"]),
        _createVNode(_component_BaseButton, {
          variant: "icon",
          title: "Delete",
          onClick: ($event: any) => (_ctx.removeField(rowIndex))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DeleteIcon)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["column-defs", "row-data"]))
}